import React, { useRef, useState, useMemo } from 'react'
import {
    TableTask,
    // IconStar,
    IconSearch,
    useWindowDimensions,
    IconTime,
    IconEdit,
} from '@Knowledge-OTP/znk-ui-components'
import Pagination from '../../common/Pagination'
import {
    InputGroup,
    TabPane, TabContent
} from 'reactstrap'
import Skeleton from 'react-loading-skeleton'
import useColumns from './Columns'
import useCalendar from '../Calendar/Sections/Calendar/useCalendar'
import { useDispatch, useSelector } from 'react-redux'
// import StatusesFilter from '../Plans/Filters/Statuses'
// import TypesFilter from './Filters/Types'
// import GraduationFilter from './Filters/Graduation'
// import CountryFilter from './Filters/Country'
import useLessonsQuery from './Model/useLessonsQuery'

//modals
import InfoLesson from '../Calendar/modal/InfoLesson'
import useInfoLesson from '../Calendar/modal/InfoLesson/useInfoLesson'

import OpenLessonModalFromUrl from '../../common/OpenLessonModalFromUrl'
import DuplicateLesson from '../Calendar/modal/DuplicateLesson'
import MakeUpLesson from '../Calendar/modal/MakeUpLesson'

import NewLesson from '../Calendar/modal/NewLesson'
import useNewLesson from '../Calendar/modal/NewLesson/useNewLesson'

import EditPayment from '../Calendar/modal/EditPayment'
import SetPendingLesson from '../Calendar/modal/SetPendingLesson'
import RescheduledLesson from '../Calendar/modal/RescheduledLesson'
import PenalizeLesson from '../Calendar/modal/PenalizeLesson'
import ChangeTimezone from '../Calendar/modal/ChangeTimezone'
import EditLesson from '../Calendar/modal/EditLesson'
import './index.css'
import WspAlert from '../Calendar/modal/WspAlert'
import SendEmailReminder from '../Calendar/modal/SendEmailReminder'
import ScheduledConflict from '../Calendar/Components/ScheduledConflict'
import ConfirmDropRescheduled from '../Calendar/modal/ConfirmDropRescheduled'
import OrientationModal from '../Calendar/modal/OrientationModal'
import ResumeOrientation from '../Calendar/modal/ResumeOrientation'
import ConfirmResetVirtualClassRoom from '../Calendar/modal/ConfirmResetVirtualClassRoom'
import CancelLesson from '../Calendar/modal/CancelLesson'
import StateFilter from '../Calendar/Sections/Filters/StateFilter'
import StudentFilter from '../Calendar/Sections/Filters/StudentFilter'
import FilterDate from './Filters/Date'
import FilterService from './Filters/Service'

import moment from 'moment-timezone'
import _ from "lodash"
import TypeLessonFilter from './Filters/TypeLesson'
import ViewToggle from '../../common/ViewToggle'
import NewActionButton from '../../common/NewActionButton'
import ResetFiltersButton from '../../common/ResetFiltersButton'
import SelectionActionBar from '../../common/SelectionActionBar'
import useTranslation from '../../i18n/useTranslation'
import CancelMultipleLessons from '../Calendar/modal/CancelMultipleLessons'
import SetPendingMultipleLessons from '../Calendar/modal/SetPendingMultipleLessons'
import { ReactComponent as IconRemove } from '../../assets/IconRemove.svg'


export const baseFilterStatus = ['missed', 'incomplete', 'noshow', 'finished', 'attended', 'upcoming', 'inprogress'] 

const shortCutList = [
    {key: 'allLessons', label: 'All Lessons'},
    {key: 'pending', label: 'Pending'},
    {key: 'upcomming', label: 'Upcoming'},
    {key: 'today', label: 'Today'},
    {key: 'inProgress', label: 'In Progress'},
    {key: 'completed', label: 'Completed'},
    {key: 'notShow', label: 'No Show'},
    {key: 'incomplete', label: 'Incomplete'},
]

const LessonsList = () => {

    const [shortCut, setShortCut] = useState('allLessons')
    const [selectedLessons, setSelectedLessons] = useState([])
    // Mobile: explicit selection mode (Select button / long-press on a card).
    const [selectionMode, setSelectionMode] = useState(false)
    const dispatch = useDispatch()
    const { breakWidth } = useWindowDimensions()
    const isMobile = breakWidth === 'SM'
    const mobileSelecting = isMobile && (selectionMode || selectedLessons.length > 0)
    const clearSelection = () => {
        setSelectedLessons([])
        setSelectionMode(false)
    }
    const { translate } = useTranslation()
    const searchInput = useRef(null)
    const { open: openInfoLesson } = useInfoLesson()
    const { open: openNewLesson } = useNewLesson()
    const defaultQuery = {
        sortField: 'startDate',
        previous: null,
        next: null,
        limit: 10,
        studentIds: [],
        endDate: null,
        startDate: null,
        planId: null,
        status: ['scheduled', 'finished'],
        /* missed,incomplete,noshow,finished,attended,upcoming,pending,inprogress */
        filterStatus: baseFilterStatus,
        educatorIds: [],
        search: null,
        serviceIds: null,
        typeLessons: null,
        //finished (attended, missed, noshow), scheduled (scheduled, incomplete), pending, draft
        // serviceIds: null,
    }
    const initQuery = {
        ...defaultQuery, startDate: moment().subtract(1, 'week').startOf('isoWeek').toISOString()
    }
    const [query, setQuery] = useState(initQuery)
    const { data, loading, refetch: refetchCalendarQuery } = useLessonsQuery(query)
    const { generateRow, config, variant } = useColumns(refetchCalendarQuery)
    const { getLessonStatus } = useCalendar()
    const { lessons, paginatedData } = useMemo(() => {
        if (data?.lessons) {
            const { docs, ...paginatedData } = data.lessons
            return {
                lessons: data?.lessons?.docs || [],
                paginatedData

            }
        }
        return { paginatedData: {}, lessons: [] }
    }, [data])
    const {
        hasNext,
        hasPrevious,
        next,
        previous,
        totalDocs
    } = paginatedData
    const [currentPage, setCurrentPage] = useState(1)
    const [upcommingLessons, setUpcommingLesson] = useState([])
    const selectedLessonsCanUseActions = selectedLessons.length > 0 && selectedLessons.every((lesson) => {
        const status = getLessonStatus(
            lesson,
            upcommingLessons.includes(lesson?.id) ? lesson.id : undefined
        ).status
        return ['scheduled', 'upcoming', 'draft'].includes(status)
    })
    const selectedLessonsCanBeSetPending = selectedLessons.length > 0 && selectedLessons.every((lesson) => {
        const status = getLessonStatus(
            lesson,
            upcommingLessons.includes(lesson?.id) ? lesson.id : undefined
        ).status
        return ['scheduled', 'upcoming'].includes(status)
    })
    const getLessonTopic = (lesson) => lesson?.individualTopic || lesson?.planTopic || lesson?.groupTopic || {}
    const canEditTogether = selectedLessons.length === 1 || (selectedLessons.length > 1 && selectedLessons.every((lesson) => {
        const first = selectedLessons[0]
        const topic = getLessonTopic(lesson)
        const firstTopic = getLessonTopic(first)
        return lesson?.service?.id && lesson.service.id === first?.service?.id && topic?.id && topic.id === firstTopic?.id
    }))
    const startBulkEdit = (lessonsToEdit = selectedLessons) => {
        if (!canEditTogether) return
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'lesson.editLessonModal',
            data: {
                isOpen: true,
                dataLesson: lessonsToEdit[0],
                selectedLessons: lessonsToEdit,
                refetch: () => refetchCalendarQuery()
            }
        })
    }
    const services = useSelector((state) => state.user.services)
    const orientation = services.find(({ isOrientation }) => isOrientation)


    const getShortcutQuery = (newShortcut) => {
        let newQuery = {}
        switch (newShortcut) {
            case 'pending':
                newQuery = { ...defaultQuery, filterStatus: ['pending'] }
                break


            case 'upcomming':
                newQuery = { ...defaultQuery, filterStatus: ['upcoming'] }
                break



            case 'today':
                newQuery = { ...defaultQuery, startDate: moment().startOf('day').toISOString(), endDate: moment().endOf('day').toISOString() }
                break



            case 'inProgress':
                newQuery = { ...defaultQuery, filterStatus: ['inprogress'] }
                break


            case 'completed':
                newQuery = { ...defaultQuery, filterStatus: ['attended', 'missed'] }
                break


            case 'notShow':
                newQuery = { ...defaultQuery, filterStatus: ['noshow'] }
                break


            case 'incomplete':
                newQuery = { ...defaultQuery, filterStatus: ['incomplete'] }
                break


            default://allLessons
                newQuery = { ...initQuery }
                break
        }
        return newQuery
    }
    const applyShortcut = (newShortcut) => {
        setUpcommingLesson([])
        setCurrentPage(1)
        const newQuery = getShortcutQuery(newShortcut)
        setQuery({ ...newQuery })
        setShortCut(newShortcut)
    }


    const canClearFilters = useMemo(() => {
        const defaultQueryShortcut = getShortcutQuery(shortCut)
        const {
            sortField,
            previous,
            next,
            limit,
            ...defaultQuery
        } = defaultQueryShortcut
        const {
            sortField: sortField2,
            previous: previous2,
            next: next2,
            limit: limit2,
            ...currentQuery
        } = query
        return !_.isEqual(currentQuery, defaultQuery) 
        //eslint-disable-next-line
    }, [shortCut, query])

    // Shared by the desktop filter bar and the mobile chip row.
    const filterChips = (
        <>
            {/* missed,incomplete,noshow,finished,attended,upcoming,pending,inprogress */}
            <StateFilter
                statusFilters={query.filterStatus}
                setStatusFilters={(filterStatus = []) => {
                    // setUpcommingLesson([])
                    setCurrentPage(1)
                    setQuery({ ...query, filterStatus })
                }}
            />

            <StudentFilter
                setUpcommingLesson={setUpcommingLesson}
                roles={['STUDENT']}
                label={'Student'}
                studentsFilters={query?.studentIds || []}
                setStudentsFilters={(studentIds) => {
                    // setUpcommingLesson([])
                    setCurrentPage(1)
                    setQuery({ ...query, studentIds })
                }}
                setLessonsState={() => { }}
                originalLessons={[]}
            />

            <StudentFilter
                roles={['EDUCATOR']}
                label={'Educators'}
                studentsFilters={query?.educatorIds || []}
                setStudentsFilters={(educatorIds) => {
                    setCurrentPage(1)
                    setQuery({ ...query, educatorIds })
                }}
                setLessonsState={() => { }}
                originalLessons={[]}
            />

            <FilterDate
                setFilters={(newDates = []) => {
                    const [start, end] = newDates
                    setCurrentPage(1)
                    setQuery({ ...query, startDate: moment(start).toISOString(), endDate: moment(end).toISOString() })
                }}
                filters={[query?.startDate, query?.endDate]}
            />

            <FilterService
                setFilters={(serviceIds) => {
                    setCurrentPage(1)
                    setQuery({ ...query, serviceIds })
                }}
                filters={query?.serviceIds || []}
            />

            <TypeLessonFilter
                setFilters={(typeLessons) => {
                    setCurrentPage(1)
                    setQuery({ ...query, typeLessons })
                }}
                filters={query?.typeLessons || []}
            />
            {
                canClearFilters && (
                <ResetFiltersButton onClick={() => applyShortcut(shortCut)} />
                )
            }
        </>
    )



    return (
        <>
            <div className={`col-12 col-md-12 px-0 d-flex flex-column justify-content-between`} style={{ minHeight: '100%' }}>
                <div className={`d-flex flex-column m-0 p-0 mx-md-6 mx-lg-7`}>
                    {isMobile && (
                        <div className='lessons-mobile-header'>
                            <h1 className='lessons-mobile-title'>Lessons</h1>
                            <div className='d-flex align-items-center'>
                                <button
                                    type='button'
                                    className='lessons-mobile-select'
                                    onClick={() => mobileSelecting ? clearSelection() : setSelectionMode(true)}
                                >
                                    {mobileSelecting ? 'Cancel' : 'Select'}
                                </button>
                                <button
                                    type='button'
                                    className='lessons-mobile-new'
                                    aria-label='New Lesson'
                                    onClick={() => openNewLesson()}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    )}
                    <div className={`container-fluid mt-2 mt-md-5 d-flex px-2 flex-column-reverse flex-md-row ${isMobile ? 'lessons-mobile-tabs' : ''}`}>
                        <div className='d-flex flex-grow-1 align-items-center znk-scroll-horizontal mt-2 pr-0 pr-md-2 mt-md-0'>
                            {/* SHORTCUTS */}
                            {
                                shortCutList.map(
                                    ({key, label}, index) => {
                                        return (
                                            <span onClick={() => {
                                                //aplica filtro de status
                                                applyShortcut(key)
                                            }} className={`tab-link nav-title ${shortCut === key ? 'active' : ''} m-0 ${index === 0 ? 'mr-3' : 'mx-3'}`}>
                                                {label}
                                            </span>
                                        )
                                    }
                                )
                            }
                        </div>
                        <div className='d-md-flex d-none align-items-center justify-content-end justify-content-md-start flex-row-reverse flex-md-row'>
                            <ViewToggle />
                            <span className={`ml-2`}>
                                <NewActionButton label='New Lesson' className='btn-table cursor-pointer' onClick={() => {
                                    openNewLesson()
                                }} />
                            </span>
                        </div>
                    </div>
                    <div className={`d-flex m-0 p-0 justify-content-between ${isMobile ? 'flex-column' : 'flex-row'}`} style={isMobile ? {} : { minHeight: '68px' }}>
                    {
                        isMobile ?
                            <div className='lessons-mobile-chips'>
                                {filterChips}
                            </div> :
                        <div className={`container-fluid mt-2 mb-4 mt-md-5 px-0 d-flex align-items-center znk-scroll-horizontal`}>
                            {filterChips}
                            <div className='ml-auto flex-shrink-0'>
                                <InputGroup className='znk-card users-table-search-group flex-nowrap' title='Search'>
                                    <form
                                        autoComplete='off'
                                        onSubmit={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            e.nativeEvent.stopImmediatePropagation()
                                        }}
                                    >
                                        <div className='d-flex flex-row position-relative users-table-search-wrapper'>
                                            <input
                                                className='znk-input users-table-search form-control'
                                                style={{ height: '35px' }}
                                                placeholder='Search'
                                                ref={searchInput}
                                                autoComplete='off'
                                                onKeyUp={(e) => {
                                                    const { key } = e
                                                    e.stopPropagation()
                                                    e.nativeEvent.stopImmediatePropagation()
                                                    if (key === 'Enter') {
                                                        setCurrentPage(1)
                                                        setQuery({ ...query, search: searchInput?.current?.value })
                                                    }
                                                }}
                                            />
                                            <span className='addon users-table-search-icon' aria-hidden='true'>
                                                <IconSearch size={14} className='text-gray' />
                                            </span>
                                        </div>
                                    </form>
                                </InputGroup>
                            </div>
                        </div>
                        }
                        {isMobile && <div className='d-flex align-items-center justify-content-end flex-shrink-0 px-2 mb-2'>
                            <InputGroup className='znk-card users-table-search-group flex-nowrap' title='Search'>
                                <form
                                    autoComplete='off'
                                    onSubmit={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        e.nativeEvent.stopImmediatePropagation()
                                    }}
                                >
                                    <div className='d-flex flex-row position-relative users-table-search-wrapper'>
                                        <input
                                            className='znk-input users-table-search form-control'
                                            style={{ height: '35px' }}
                                            placeholder='Search'
                                            ref={searchInput}
                                            autoComplete='off'
                                            onKeyUp={(e) => {
                                                const { key } = e
                                                e.stopPropagation()
                                                e.nativeEvent.stopImmediatePropagation()
                                                if (key === 'Enter') {
                                                    setCurrentPage(1)
                                                    setQuery({ ...query, search: searchInput?.current?.value })
                                                }
                                            }}
                                        />
                                        <span className='addon users-table-search-icon' aria-hidden='true'>
                                            <IconSearch size={14} className='text-gray' />
                                        </span>
                                    </div>
                                </form>
                            </InputGroup>
                            <ViewToggle className='ml-2' />
                        </div>}
                    </div>
                    <div className={`m-0 py-0 px-2 ${isMobile && selectedLessons.length > 0 ? 'lessons-list-mobile-bar-space' : ''}`}>
                        <TabContent activeTab={loading ? 'loading' : 'table'}>
                            <TabPane tabId={`loading`}>
                                <div className={`p-0 m-2`}>
                                    <Skeleton count={10} height={43} className={`mb-2`} style={{ borderRadius: '12px' }} />
                                </div>
                            </TabPane>
                            <TabPane tabId={`table`}>
                                <TableTask
                                    canCreated={false}
                                    multiSelect
                                    variant={variant}
                                    selectionMode={isMobile && selectionMode}
                                    onSelectionModeChange={setSelectionMode}
                                    longPressToSelect={isMobile}
                                    selectedRows={selectedLessons}
                                    onSelectionChange={setSelectedLessons}
                                    selectionActions={(selectedRows) => (
                                        <SelectionActionBar
                                            bottomCentered={!isMobile}
                                            mobile={isMobile}
                                            count={selectedRows.length}
                                            selection={selectedRows}
                                            label={`${selectedRows.length === 1
                                                ? translate('lesson.multipleselection.lessonselec')
                                                : translate('lesson.multipleselection.lessonsselec')}`}
                                            onClear={clearSelection}
                                            actions={[
                                                {
                                                    key: 'edit',
                                                    Icon: IconEdit,
                                                    label: 'Edit',
                                                    variant: 'edit',
                                                    disabled: !canEditTogether,
                                                    title: !canEditTogether ? 'Select lessons with the same service and topic to edit together.' : '',
                                                    onClick: () => startBulkEdit(selectedRows)
                                                },
                                                ...(selectedLessonsCanBeSetPending ? [
                                                {
                                                    key: 'pending',
                                                    Icon: IconTime,
                                                    label: translate('modal.infolesson.leavepending'),
                                                    variant: 'pending',
                                                    onClick: () => dispatch({
                                                        type: 'SET_DATA_MODAL_FORM_LIST',
                                                        payload: 'lesson.setPendingMultiple',
                                                        data: { isOpen: true, lessonsId: selectedRows.map(({ id }) => id) }
                                                    })
                                                }
                                                ] : []),
                                                ...(selectedLessonsCanUseActions ? [
                                                {
                                                    key: 'remove',
                                                    Icon: IconRemove,
                                                    label: translate('lesson.multipleselection.remove'),
                                                    variant: 'remove',
                                                    onClick: () => dispatch({
                                                        type: 'SET_DATA_MODAL_FORM_LIST',
                                                        payload: 'lesson.cancelMultiple',
                                                        data: { isOpen: true, lessonsId: selectedRows.map(({ id }) => id) }
                                                    })
                                                }
                                                ] : [])
                                            ]}
                                        />
                                    )}
                                    onClickCreate={() => { }}
                                    onClick={(lesson) => {
                                        if (orientation?.id === lesson.service.id) {
                                            dispatch({
                                                type: 'SET_DATA_MODAL_FORM_LIST',
                                                payload: `plan.orientationLessonModal`,
                                                data: {
                                                    isOpen: true,
                                                    dataLesson: lesson
                                                }
                                            }
                                            )
                                        } else {
                                            openInfoLesson(lesson)
                                        }
                                    }}
                                    loading={false}
                                    className={`my-2 cursor-pointer`}
                                    config={config}
                                    rows={(lessons || []).map((item) => {
                                        return generateRow(item, upcommingLessons)
                                    })}
                                />
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
                <Pagination
                    className={breakWidth === 'SM' ? 'px-0' : `px-7`}
                    bottomFix
                    pageSize={query?.limit || 10}
                    changeSize={(limit) => {
                        setQuery({ ...query, limit })
                    }}
                    clickNext={() => {
                        if (hasNext && !loading) {
                            setCurrentPage(currentPage + 1)
                            setQuery({ ...query, next: next, previous: null })
                        }
                    }}
                    clickPrevious={() => {
                        if (hasPrevious && !loading && currentPage > 1) {
                            setCurrentPage(currentPage - 1)
                            setQuery({ ...query, previous: previous, next: null })
                        }
                    }}
                    loading={loading}
                    hasPrevious={hasPrevious}
                    hasNext={hasNext}
                    activePage={currentPage}
                    pageCount={Math.ceil((totalDocs || 0) / (query?.limit || 1))}
                />
            </div>
            <InfoLesson refetchCalendarQuery={() => {
                refetchCalendarQuery()
            }} />
            <OpenLessonModalFromUrl />
            <DuplicateLesson refetchPendingLessons={() => {
                refetchCalendarQuery()
            }} />
            <MakeUpLesson />
            <NewLesson refetchPendingLessons={() => {
                refetchCalendarQuery()
            }} />
            <EditPayment refetchPendingLessons={() => {
                refetchCalendarQuery()
            }} />
            <SetPendingLesson refetchPendingLessons={() => {
                refetchCalendarQuery()
            }} />
            <RescheduledLesson />
            <PenalizeLesson />
            <ChangeTimezone />
            <EditLesson refetchCalendar={() => {
                refetchCalendarQuery()
            }} />
            <WspAlert />
            <SendEmailReminder />
            {/* <InfoStudent refetch={() => { setRefetchIn(true) }} /> */}
            {/* <InfoEducator countries={countries} refetch={() => { setRefetchIn(true) }} /> */}
            <ScheduledConflict />
            <ConfirmDropRescheduled />
            <OrientationModal refetch={refetchCalendarQuery} />
            <ResumeOrientation />
            <ConfirmResetVirtualClassRoom />
            <CancelLesson
                setLessonsSelected={() => { }}
                lessonsSelected={[]}
                refetch={() => {
                    refetchCalendarQuery()
                }}
            />
            <CancelMultipleLessons
                refetchCalendarQuery={refetchCalendarQuery}
                setLessonsSelected={setSelectedLessons}
            />
            <SetPendingMultipleLessons
                refetchCalendarQuery={refetchCalendarQuery}
                setLessonsSelected={setSelectedLessons}
            />
        </>
    )
}

export default LessonsList
